<template>
    <div class="table_wrap">
        <div class="c_table_wrap marginB15">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tr>
                    <td class="c_t_title">로고 설정</td>
                    <td colspan="3">
                        <div @click="changeType('siteLogo')" class="stori_title">
                            <el-upload
                                ref="siteLogo"
                                class="avatar-uploader"
                                action=""
                                list-type="picture-card"
                                :auto-upload="false"
                                :show-file-list="false"
                                :file-list="siteLogo"
                                :on-change="onlyOnePhotoChange"
                            >
                                <i class="el-icon-plus avatar-uploader-icon" v-if="siteLogo.length === 0"></i>
                                <div v-else>
                                    <img :src="siteLogo[0].url" alt="" class="avatar">
                                </div>
                                <div class="el-upload__tip" style="font-size:14px; color:red;" slot="tip">권장이미지 : *px *
                                    *px
                                </div>
                            </el-upload>
                            <div class="input_error">{{ validation.firstError('siteLogo') }}</div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div class="title">
            기본정보
            <div class="clear"></div>
        </div>
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tr>
                    <td class="c_t_title">대표자명</td>
                    <td>
                        <div>
                            <el-input v-model="ci_boss_name"></el-input>
                            <div class="input_error">{{ validation.firstError('ci_boss_name') }}</div>
                            <div></div>
                        </div>
                    </td>
                    <td class="c_t_title">회사명</td>
                    <td>
                        <div>
                            <el-input v-model="ci_name"></el-input>
                            <div class="input_error">{{ validation.firstError('ci_name') }}</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">개인정보 관리책임자명</td>
                    <td>
                        <div>
                            <el-input v-model="ci_policy_name"></el-input>
                            <div class="input_error">{{ validation.firstError('ci_policy_name') }}</div>
                        </div>
                    </td>
                    <td class="c_t_title">회사주소</td>
                    <td>
                        <div>
                            <el-input v-model="ci_addr"></el-input>
                            <div class="input_error">{{ validation.firstError('ci_addr') }}</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">개인정보 관리책임자 이메일</td>
                    <td>
                        <div>
                            <el-input v-model="ci_policy_email"></el-input>
                            <div class="input_error">{{ validation.firstError('ci_policy_email') }}</div>
                        </div>
                    </td>
                    <td class="c_t_title">사업자 등록번호</td>
                    <td>
                        <div>
                            <el-input v-model="ci_business_regi"></el-input>
                            <div class="input_error">{{ validation.firstError('ci_business_regi') }}</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">대표번호</td>
                    <td>
                        <div>
                            <el-input v-model="ci_tel"></el-input>
                            <div class="input_error">{{ validation.firstError('ci_tel') }}</div>
                        </div>
                    </td>
                    <td class="c_t_title">부가통신 사업자번호</td>
                    <td>
                        <div>
                            <el-input v-model="ci_comm_regi"></el-input>
                            <div class="input_error">{{ validation.firstError('ci_comm_regi') }}</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">팩스번호</td>
                    <td>
                        <div>
                            <el-input v-model="ci_fax"></el-input>
                            <div class="input_error">{{ validation.firstError('ci_fax') }}</div>
                        </div>
                    </td>
                    <td class="c_t_title">법인등록번호</td>
                    <td>
                        <div>
                            <el-input v-model="ci_corp_regi"></el-input>
                            <div class="input_error">{{ validation.firstError('ci_corp_regi') }}</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">통신판매업 번호</td>
                    <td colspan="3">
                        <div>
                            <el-input v-model="ci_online_regi"></el-input>
                            <div class="input_error">{{ validation.firstError('ci_online_regi') }}</div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import elFileMixins from "@/mixins/elFileMixins";
import siteValidator from "@/mixins/validators/SiteValidator";
import EventBus from "@/mixins/event-bus";
import {mapState} from "vuex";
import alertMixins from "@/mixins/alertMixins";
import ApiFileUpload from "@/mixins/ApiFileUpload";
import util from "@/mixins/util";
import {getTokenObj} from "@/mixins/Auth";

export default {
    name: "SiteSettingComponent",
    mixins: [elFileMixins, siteValidator, alertMixins, ApiFileUpload],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            isRunning: false,
            fileInfo: [
                {
                    fileName: 'siteLogo',
                    fileType: 'siteLogo',
                },
            ],
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.setInitData();
        EventBus.$on('runSetting', this.runSetting);
    },
    beforeDestroy() {
        EventBus.$off('runSetting');
    },
    destroyed() {
    },
    computed: {
        ...mapState({
            SiteLogo: state => state.common.SiteLogo,
            SiteInfo: state => state.common.SiteInfo,
        })
    },
    methods: {
        setInitData() {
            if (this.SiteLogo.hasOwnProperty('thumb_url')) {
                this.siteLogo.push(this.SiteLogo);
            }

            this.ci_boss_name = this.SiteInfo.ci_boss_name;
            this.ci_name = this.SiteInfo.ci_name;
            this.ci_policy_name = this.SiteInfo.ci_policy_name;
            this.ci_addr = this.SiteInfo.ci_addr;
            this.ci_policy_email = this.SiteInfo.ci_policy_email;
            this.ci_comm_regi = this.SiteInfo.ci_comm_regi;
            this.ci_business_regi = this.SiteInfo.ci_business_regi;
            this.ci_tel = this.SiteInfo.ci_tel;
            this.ci_fax = this.SiteInfo.ci_fax;
            this.ci_corp_regi = this.SiteInfo.ci_corp_regi;
            this.ci_online_regi = this.SiteInfo.ci_online_regi;
        },
        _checkValidator() {
            let validateArr = ['siteLogo', 'ci_name', 'ci_addr', 'ci_boss_name', 'ci_business_regi', 'ci_corp_regi', 'ci_tel', 'ci_fax', 'ci_comm_regi', 'ci_online_regi', 'ci_policy_name', 'ci_policy_email'];
            return this.$validate(validateArr).then(success => {
                if (!success) {
                    this.errorAlert('필수데이터를 확인해주세요.')
                    return success
                }
                return success;
            })
        },
        _makeParams() {
            return {
                siteLogo: this.siteLogo,
                ci_name: this.ci_name,
                ci_addr: this.ci_addr,
                ci_boss_name: this.ci_boss_name,
                ci_business_regi: this.ci_business_regi,
                ci_corp_regi: this.ci_corp_regi,
                ci_tel: this.ci_tel,
                ci_fax: this.ci_fax,
                ci_comm_regi: this.ci_comm_regi,
                ci_online_regi: this.ci_online_regi,
                ci_policy_name: this.ci_policy_name,
                ci_policy_email: this.ci_policy_email,
            }
        },
        async runSetting() {
            if (this.isRunning) {
                return false;
            }
            this.isRunning = true;
            let validator = await this._checkValidator();
            if (!validator) {
                this.isRunning = false;
                return false;
            }
            EventBus.$emit('changeLoading', true);
            let params = this._makeParams();

            try {
                this.isRunning = false;
                EventBus.$emit('changeLoading', false);
                this.$api.$common.updateConfigInfo(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.Type === 1) {
                        this.runApiUploadFiles(this.fileInfo, 1).then(res => {
                            this.afterFunc();
                        })
                    } else {
                        this.errorAlert('수정에 실패하였습니다.')
                        this.isRunning = false;
                        EventBus.$emit('changeLoading', false);
                        return false;
                    }
                })
            } catch (e) {
                console.log(e)
                this.isRunning = false;
                EventBus.$emit('changeLoading', false);
            }
        },
        afterFunc() {
            let token = this.$localStorage.get('token');
            this.$store.dispatch('common/setSiteLogo', {token: token});
            this.$store.dispatch('common/setSiteInfo', {token: token});

            EventBus.$emit('changeLoading', false)
            this.createAlert({
                content: '사이트 정보를 수정하였습니다.',
                hide: () => {
                }
            })
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
